var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-tooltip",
    {
      attrs: {
        placement: "bottom-start",
        effect: "light",
        "popper-class": "custom-select-tooltip",
        disabled: !_vm.hasTooltipContent,
        enterable: "",
      },
      scopedSlots: _vm._u([
        {
          key: "content",
          fn: function () {
            return [
              _c(
                "div",
                {
                  staticClass: "tooltip-names",
                  attrs: { "aria-label": "selected-names" },
                },
                _vm._l(_vm.tooltipItems, function (name, i) {
                  return _c(
                    "span",
                    {
                      key: i,
                      staticClass: "tooltip-name",
                      attrs: { title: name },
                    },
                    [_vm._v("\n        " + _vm._s(name) + "\n      ")]
                  )
                }),
                0
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "form-group",
          on: {
            keydown: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
              if ($event.target !== $event.currentTarget) return null
            },
          },
        },
        [
          _vm.label
            ? _c("label", { attrs: { for: _vm.name } }, [
                _vm._v("\n      " + _vm._s(_vm.label) + "\n      "),
                _vm.required
                  ? _c("span", { staticClass: "text-danger" }, [_vm._v(" *")])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-select",
            {
              ref: "elSelect",
              class: [
                "custom-el-select",
                { "has-error": _vm.errors && _vm.errors[_vm.errorKey] },
              ],
              attrs: {
                id: _vm.name,
                name: _vm.name,
                multiple: _vm.multiple,
                disabled: !!_vm.disabled,
                placeholder: _vm.placeholder,
                clearable: _vm.multiple || _vm.clearable,
                filterable: _vm.filterable,
                remote: _vm.remote,
                "remote-method": _vm.onRemoteSearch,
                "reserve-keyword": true,
                loading: _vm.isLoading,
                "collapse-tags": _vm.multiple,
                "collapse-tags-tooltip": "",
                "popper-class": "element-select-popper-" + _vm._uid,
                "value-key": _vm.valueKey,
              },
              on: {
                change: _vm.onElChange,
                clear: _vm.onClear,
                "visible-change": _vm.onVisibleChange,
              },
              scopedSlots: _vm._u([
                {
                  key: "empty",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "my-empty-message" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.isLoading
                                ? _vm.Lang.get("messages.loading")
                                : _vm.Lang.get("messages.no_options")
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.internalValue,
                callback: function ($$v) {
                  _vm.internalValue = $$v
                },
                expression: "internalValue",
              },
            },
            [
              _vm._l(_vm._options, function (opt) {
                return _c("el-option", {
                  key: _vm.optionKey(opt),
                  attrs: { label: _vm.getLabel(opt), value: opt },
                })
              }),
              _vm._v(" "),
              _vm._v(" "),
              !_vm._options.length
                ? _c("div", { staticClass: "my-empty-message" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.Lang.get("messages.no_options")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _vm.errors && _vm.errors[_vm.errorKey]
            ? _c("small", {
                staticClass: "form-text text-danger",
                domProps: { textContent: _vm._s(_vm.errors[_vm.errorKey][0]) },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }